export default __webpack_public_path__ + "static/media/slq.a569e1a6.jpeg";